
<div class="profile-view">
  <profile-profile
    :profile-id="resolvedProfileId"
    page
  />
</div>
